import React, {useState} from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import Button from "react-bootstrap/Button";
import {Col, Row, Badge, Spinner} from "react-bootstrap";
import Input from "../../../../common/Input";
import Alert from "react-bootstrap/Alert";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import {asArray} from "../constants";
import Dropdown from "../../../../primer/Dropdown";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";

const ActiveTPModal = ({show, setShow, selectedTP, setSelectedTP, newStepCallback, repeatStepCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const activeVisit = useSelector((state) => state.PRESCRIPTION.activeVisit);
    const treatmentProtocol = selectedTP ? selectedTP.treatmentProtocol : null;
    const steps = selectedTP ? [...asArray(selectedTP?.steps?.step)].sort((a, b) => Number(a.id) - Number(b.id)) || [] : [];

    const [repeatModal, setRepeatModal] = useState(false);
    const [stepToRepeat, setStepToRepeat] = useState(null);
    const [loadingRepeat, setLoadingRepeat] = useState(false);
    const [selectedICD10s, setSelectedICD10s] = useState([]);

    const icd10s = selectedTP ? asArray(selectedTP?.treatmentProtocol?.treatmentProtocolICD10s?.treatmentProtocolICD10) : [];
    const icd10sOptions = icd10s.map((obj) => {
        return {
            value: obj.icd10.id,
            label: `${obj.icd10.code} - ${obj.icd10.title}`,
        }
    })

    const handleClose = () => {
        setShow(false);
        setSelectedTP(null);
    }

    const handleNewStep = () => {
        newStepCallback(selectedTP);
        handleClose();
    }

    const handleRepeatStep = () => {
        if (selectedICD10s.length === 0) {
            return toast.error("Παρακαλώ επιλέξτε τουλάχιστον μία διάγνωση.");
        }
        setLoadingRepeat(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/repeat-tp-step`, {
            company: company.id,
            amka: activeVisit.amka,
            tpId: selectedTP.treatmentProtocol.id,
            stepId: stepToRepeat.id,
            selectedICD10s: selectedICD10s,
        }).then((res) => {
            setLoadingRepeat(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής επανάληψη βήματος Θ.Π.");
                setRepeatModal(false);
                setShow(false);
                if (typeof repeatStepCallback === "function") repeatStepCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingRepeat(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const formatStepSubstances = (step) => {
        const subs = step?.stepSubstances?.stepSubstance ? asArray(step.stepSubstances.stepSubstance) : [];

        if (subs.length > 0) {
            return (
                <React.Fragment>
                    {subs.map((o) => o.description).join(", ")}
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment></React.Fragment>
            )
        }
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => handleClose()} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Θεραπευτικό Πρωτόκολλο {!isEmpty(treatmentProtocol?.title) ? `(${treatmentProtocol.title})` : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedTP && (
                        <React.Fragment>
                            <Row>
                                <Col md={4}>
                                    <Input
                                        label={"Τίτλος"}
                                        disabled={true}
                                        placeholder={"-"}
                                        value={!isEmpty(treatmentProtocol?.title) ? `${treatmentProtocol.title}` : ""}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Input
                                        label={"Ημερομηνία ένταξης στο Πρωτόκολλο"}
                                        disabled={true}
                                        placeholder={"-"}
                                        value={selectedTP.insertDate ? moment(selectedTP.insertDate, "YYYY-MM-DD HH:mm:ss").isValid()
                                                ? moment(selectedTP.insertDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY στις HH:mm") : selectedTP.insertDate
                                            : "-"}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Input
                                        label={"Ημερομηνία τελευταίας Συνταγογράφησης"}
                                        disabled={true}
                                        placeholder={"-"}
                                        value={selectedTP.lastUsedDate ? moment(selectedTP.lastUsedDate, "YYYY-MM-DD HH:mm:ss").isValid()
                                                ? moment(selectedTP.lastUsedDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY στις HH:mm") : selectedTP.lastUsedDate
                                            : "-"}
                                    />
                                </Col>
                            </Row>
                            <Row className={"mt-2"}>
                                <Col md={12}>
                                    <Alert variant={"secondary"}>
                                        <strong>MDC:</strong> {treatmentProtocol?.mdc?.code} - {treatmentProtocol?.mdc?.description}<br/>
                                        {!isEmpty(treatmentProtocol?.description) && (
                                            <span><strong>Περιγραφή:</strong> {treatmentProtocol?.description}<br/></span>
                                        )}
                                        {!isEmpty(treatmentProtocol?.documentationUrl) && (
                                            <span><strong>Σχετικό URL:</strong> <a href={treatmentProtocol?.documentationUrl} target={"_blank"} rel={"noreferrer"}>{treatmentProtocol?.documentationUrl}</a><br/></span>
                                        )}
                                        {!isEmpty(treatmentProtocol.notes) && (
                                            <span><strong>Σημειώσεις:</strong> {treatmentProtocol.notes}<br/></span>
                                        )}
                                    </Alert>
                                </Col>
                            </Row>
                            <div className={"text-muted mt-2"}><i>Βήματα Θ.Π.</i></div>
                            <table className={"simpleClassicTable mt-1"}>
                                <colgroup>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Βήμα Αγωγής</th>
                                    <th>Δραστικές Ουσίες</th>
                                    <th>Ημ/νία Ένταξης στο Βήμα</th>
                                    <th>Ημ/νία Τελευταίας Συνταγ/σης</th>
                                    <th>Ημερομηνία Επανεκτίμησης</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {steps.map((step, idx) => (
                                    <tr key={`activeTPSteps-${idx}`}>
                                        <td>{step.description}</td>
                                        <td>{formatStepSubstances(step)}</td>
                                        <td>{step.insertDate ? moment(step.insertDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY στις HH:mm") : ""}</td>
                                        <td>{step.lastUsedDate ? moment(step.lastUsedDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY στις HH:mm") : ""}</td>
                                        <td>{step.expiryDate ? moment(step.expiryDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY στις HH:mm") : ""}</td>
                                        <td>
                                            {step?.canRepeatStep === "true" && (
                                                <Badge bg={"primary"} title={"Επανάληψη βήματος"} style={{cursor: "pointer"}} onClick={() => {
                                                    setRepeatModal(true);
                                                    setStepToRepeat(step);
                                                    const autoFill = selectedTP ? asArray(selectedTP?.treatmentProtocolICD10s?.treatmentProtocolICD10) : [];
                                                    setSelectedICD10s(autoFill.flatMap((o) => o.icd10.id));
                                                }}>
                                                    <i className="fa-solid fa-repeat"></i>
                                                </Badge>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <div style={{textAlign: "center"}} className={"mt-2"}>
                                <Button size={"sm"} onClick={() => handleNewStep()}>Νέο βήμα</Button>
                            </div>
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={repeatModal} onHide={() => setRepeatModal(false)} dialogClassName={"modal42PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Επανάληψη βήματος</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Παρακαλώ επιλέξτε τις διαγνώσεις ICD-10 που επιθυμείτε να επαναληφθεί το βήμα.
                    <Dropdown
                        className={"mt-2"}
                        name={"selectedICD10s"}
                        label={"Διαγνώσεις ICD10"}
                        multiSelect={true}
                        defaultValue={icd10sOptions.filter((el) => selectedICD10s.includes(el.value))}
                        options={icd10sOptions}
                        onChange={(e) => setSelectedICD10s(e.flatMap((o) => o.value))}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setRepeatModal(false)}>
                        Ακύρωση
                    </Button>
                    <Button variant="primary" onClick={() => handleRepeatStep()} disabled={loadingRepeat}>
                        Επανάληψη Βήματος {loadingRepeat && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default ActiveTPModal;
